<template>
  <div
    class="modal fade"
    :class="{ in: isShowModal, active: isShow }"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    v-show="isShow"
  >
    <div class="modal-bg" @click="onModalClose"></div>
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div
          class="common-modal-close"
          data-dismiss="modal"
          aria-label="Close"
          @click="onModalClose"
        >
          <img
            class="common-modal-close"
            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg"
          />
        </div>

        <div class="modal-body">
          <div class="booking_rule_hd">
            乘客票据合同<br />
            （包括拒绝承运政策以及乘客健康、安全和行为政策）
          </div>
          <div class="booking_rule_bd">
            <p style="text-align: center; font-weight: bold;">致乘客的重要通知</p>
            <p>
              <strong
                >您的乘客票据合同包含了对乘客权利的重要限制。您需仔细阅读本合同的所有条款，并应当特别注意第3条、第6条以及第10条至第12条之规定(该等条款对我方责任和您的诉讼权利进行了限制)，并保留此合同供以后参考。</strong
              >
            </p>
            <p>
              <strong
                >本合同要求通过仲裁方式解决特定纠纷，并要求放弃通过法院诉讼审理上述纠纷的任何权利。请参见以下第11条之规定。</strong
              >
            </p>
            <p>
              <strong
                >此外，请仔细阅读第4条以及皇家加勒比国际游轮中文官网（http://www.rcclchina.com.cn/）所公布的各项与新冠防护相关的条款、条件、政策、流程及要求。</strong
              >
            </p>
            <p><strong>1. 介绍</strong></p>
            <p>
              &nbsp; &nbsp;
              就本协议项下的游轮巡游和游轮观光，本乘客票据合同（下称
              &ldquo;票据合同&rdquo;）规定了适用于游轮乘客（定义见下述第2.g条）和承运人（定义见下述第2.b条）之间关系的条款和条件。除非本合同另有其它明确规定，本协议将取代承运人和乘客就本协议事项或游轮巡游或游轮观光所作出或达成的任何其它书面或口头声明或协议，但游轮的运营方为符合国际邮轮协会（下称&ldquo;邮轮协会&rdquo;）的会员要求而已采用的国际邮轮协会乘客权利法案（下称&ldquo;邮轮协会乘客权利法案&rdquo;）的条款除外。此外，承运人在票据合同第4条和其他条款简述了其关于COVID-19新冠病毒防护的各项政策和流程（&ldquo;新冠相关政策和流程&rdquo;）。承运人保留权利根据相关政府要求在必要情况下对该等政策进行变更或调整，且更新版本会发布在皇家加勒比国际游轮中文官网（<a
                href="http://www.rcclchina.com.cn/"
                >http://www.rcclchina.com.cn/</a
              >）供查看。如网站公布的政策与流程与本票据合同的规定有任何冲突，应以网站公布政策和流程为准。
            </p>
            <p>
              &nbsp; &nbsp;
              无论乘客是否签署了本票据合同，只要其做出了购买或使用本票据合同的行为，均视为乘客已代表自己及其他所有在本票据合同项下的游客（包括但不限于随行未成年人及其他本合同项下的同行客人）同意受本票据合同条款和条件之约束。除非经承运人高级职员的书面签署，否则不得对本票据合同进行任何修改。除此之外，乘客确认其可获知承运人产品手册、网址<a
                href="http://www.rcclchina.com.cn/"
                >http://www.rcclchina.com.cn/</a
              >或旅行社告知的条件和条款，包括但不限于某些付款条款如最低订金要求及到期付款日条款，并应遵守该等条款和条件。若上述手册或网页资料与本票据合同的规定出现了任何冲突之处，则应适用本票据合同之规定。乘客可随时通过网址<a
                href="http://www.rcclchina.com.cn/"
                >http://www.rcclchina.com.cn/</a
              >
              查询到最新版本的乘客票据合同。
            </p>
            <p></p>
            <p><strong>2. 定义</strong></p>
            <p>
              a.
              &ldquo;协议&rdquo;或&ldquo;合同&rdquo;指本票据合同规定的条款和条件，以及您因本游轮/游轮观光而需支付的游轮巡游/游轮观光费用。上述所列的项目共同构成乘客和承运人就游轮巡游/游轮观光而达成的全部协议。
            </p>
            <p>
              b. &ldquo;承运人&rdquo;包括：(i)游轮或任何替代游轮；(ii)第 21
              条所详述的游轮承运人；以及(iii)就任何游轮观光的陆地游部分而言，陆地游的运营方（&ldquo;陆地游运营方&rdquo;），以及本款上述第(i),
              (ii) 和
              (iii)项中所列实体的所有人、管理人、承租人、关联公司、继承人和受让方。承运人还包括本款上述各项中所列实体的管理人员、董事、员工、代理人、船员或领航员。本票据合同中所列的承运人责任限制或排除条款，以及本协议中规定的所有权利、抗辩或豁免，均适用于并保护承运人的代理人、独立合同方、特许经营商和供应商，游轮或其他交通工具停靠访问的所有岸边物业的所有人和承运人，以及游轮或交通工具（或其任何部件）的所有人、设计人、安装人、供应商和生产商，以及上述所有实体的员工和服务人员，以及本款中所确定任何当事人所拥有或提供的任何种类小艇、船或设施。
            </p>
            <p>
              c.
              &ldquo;游轮巡游&rdquo;指本文件涵盖的特定巡游，其可能被变更，且应包含游客在登船或离船的时间段以及游轮靠港后游客在岸上的时间段。
            </p>
            <p>
              d.
              &ldquo;游轮巡游/游轮观光费用&rdquo;指为本游轮巡游或游轮观光应支付的费用，无论该费用是否已由乘客进行支付，但其不包括如航空运输、照片、娱乐活动、电话、或医疗服务等其他可另行购买的产品或服务的费用，不包括任何政府机关或准政府机关就乘客、游轮、泊位或游轮吨位所征收的任何税费，不包括任何航空公司、铁路公司、汽车公司、酒店或其它任何第三方所征收的任何燃油附加费、安保附加费或其它任何类似费用（且上述公司或第三方有权对上述费用的数额进行调整，且在其要求支付时，乘客应将上述费用及时支付给上述公司或第三方）。对于包含航空旅行项目的游轮观光活动而言，其航空费用均已包含在游轮观光费用之中。
            </p>
            <p>
              &nbsp; &nbsp;
              承运人保留在发生不可预期情形（包括但不限于燃料费用的增加）时，收取附加费用的权利。承运人可自行决定对已有的和新建的预订收取任何该等附加费用（无论乘客此前是否已全额支付了预订的的费用）。上述附加费用未包括在游轮巡游/游轮观光费用之中。
            </p>
            <p>
              e.&ldquo;游轮观光&rdquo;指由承运人正式公布并提供的综合度假产品，包括相关的游轮巡游和陆地游项目。
            </p>
            <p>f. 游轮的&ldquo;承运人&rdquo;指下述第21条中所列的相关实体。</p>
            <p>
              g.
              "乘客"、&ldquo;游客&rdquo;或&ldquo;您&rdquo;指在本票据合同项下出游的所有人员及受其监护的其他人，以及上述人员的各自继承人和代理人。"乘客"
              的单数形式将含有复数意思，任何表示男性乘客的用词同样包含女性乘客。
            </p>
            <p>
              h.
              &ldquo;陆地游&rdquo;指游轮观光中所包含的陆地游览项目，该陆地游可在巡游首次登船之前提供，也可在巡游完成最后离船之后提供。
            </p>
            <p>
              i.
              &ldquo;交通工具&rdquo;指陆地游运营方为陆地游而提供的有轨客车、公交车及其它任何运输或交通工具。
            </p>
            <p>
              j.
              "游轮"指由承运人所有的、承租的或运营的且乘客用其出游或针对其提出索赔请求的船只，以及为履行本票据合同而使用的其它任何替代船只。
            </p>
            <p></p>
            <p><strong>3. 行李、财产和责任限制</strong></p>
            <p>
              a. 行李限制和禁止物品.
              每一成年乘客允许携带上船并办理登船手续的行李仅限于本次游轮观光活动合理所需的衣物和个人物品，包括手提箱、行李箱、旅行袋、背包、手提包、含衣物的衣架、化妆品和类似物品。在任何情况下，在上船、办理登船手续或陆地游活动之时，任何乘客均不得携带任何非法的管制物品、烟火、活体动物（但以下第13.d条中另有其它规定的除外）、武器、军火、爆炸物品、其它危险物品或任何其它相关法律或承运人政策禁止的物品。对于乘客所携带的任何物品，若承运人认为其不符合相关要求，则承运人有权拒绝乘客将该物品携带上船或携带至任何交通工具。
            </p>
            <p>
              b. 行李灭失或损毁的责任.
              无论行李是否打包装箱，承运人均无需对乘客行李的任何灭失或损毁负责，除非承运人对该灭失或损毁负有过失责任。对于在任何航空运输或陆上运输过程中乘客财产所产生的灭失或损毁，其责任均应由该等运输服务的提供商单独承担，并适用相关责任限制之规定。
            </p>
            <p>
              c. 财产丢失或损毁的责任限制.
              无论法律或本协议中是否有任何相反规定，对于在游轮观光过程中的陆地游部分乘客所出现的任何财产灭失或损毁，承运人就此承担的责任限定于每位乘客$300.00美元。无论法律或本协议中另有其它任何规定，对于在游轮巡游（或游轮观光中的游轮巡游部分）中乘客的财产灭失或损毁，承运人责任限定如下：
            </p>
            <p>
              (1)
              承运人在每次巡游中对每名旅客自带行李的灭失或损坏所承担的责任，在任何情况下，均不得超过833个特别提款权；
            </p>
            <p>
              (2)
              承运人在每次巡游中对每名旅客的自带行李以外的其他行李的灭失或损坏所承担的责任，在任何情况下，均不得超过1200个特别提款权。
            </p>
            <p>
              d. 携带物品限制.
              承运人不保证乘客可将任何营生用品、家用物品（包括但不限于器具及家具）、易碎物品或高价物品、贵金属、珠宝、文件、可流通票据或其它贵重物品作为行李进行携带。每位乘客承诺不会将上述物品放置在任何容器或箱柜中作为行李交付承运人，若乘客违反此承诺将该等物品交付承运人，则免除承运人对上述物品灭失或毁损的任何责任。在任何情况下，承运人均无需对其行李或财产的正常损耗承担责任，且无需对其珠宝、现金、可流通票据、摄像设备/电子设备、医疗器具或娱乐设施、牙科硬件、眼镜、药品或其它贵重物品的灭失或损毁承担责任，除非乘客已将上述贵重物品在船上交付给承运人保管且由承运人出具代保管证明（陆地游运营方不接受对贵重物品的寄存）。承运人所保管的任何贵重物品如丢失或损毁，承运人承担的责任将不得超出上述第3.c条中规定的赔偿限额。
            </p>
            <p></p>
            <p>
              <strong>4. 公共健康、新冠相关政策和流程、以及知悉同意风险</strong>
            </p>
            <p>
              a. 风险同意.
              乘客在预订或者乘坐游轮出行前，应当考虑其自身因接触病菌而严重患病的风险，并在此基础上做出慎重的出行决定。重病高风险人群建议在预订或开启行程之前征询其医生的意见。<strong
                >乘客知悉、理解并确认，在游轮巡游过程中（包括在游轮上、在港口及登船区域、在岸上观光过程中）以及在往返游轮的途中，乘客或其他乘客可能会存在接触传染性疾病病毒（如新冠病毒、流感、诺如病毒等）的风险。乘客理解并同意，这种风险在大多数存在人员互动或共用公用设施情形的活动中都存在，这一固有风险是超出承运人控制范围的，而且也无法被完全排除。乘客知悉并自愿同意接受本协议下的该等风险，包括因接触该等病毒导致严重患病甚或死亡的风险，及/或产生任何性质的损害、损失、成本或支出的风险。</strong
              >
            </p>
            <p>
              b. 同意遵守新冠相关政策和流程.
              承运人的新冠相关政策和流程是根据适用国家和地区政府卫生部门等的要求和指引而制定的，也会遵守游轮到访国家和地区适用的规定及/或政府的要求和指引。乘客知悉，该等要求可能会发生变更，因此承运人的新冠相关政策和流程也会因此调整。乘客同意，在游轮巡游所有过程中（包括登船前、在船上时、停靠港口时、参加岸上观光时、离船时），不仅将遵守承运人目前公示的新冠相关政策和流程，也将遵守承运人可能在网站上不时所公布的更新要求。乘客同意遵守承运人的新冠相关政策和流程是本票据合同不可分割的一部分内容。
            </p>
            <p>
              c. 新冠相关政策和流程.
              乘客理解，承运人的新冠相关政策和流程可能或将包括（但并不限于）以下要求：（1）在登船前，提供准确、真实和完整的健康问询表格，就承运人在表格中所提出的问题提供所有健康或出行相关信息；（2）对每个乘客在登船前及/或定期进行测试和测量体温；（3）修改活动的客容量（包括但不限于船上的餐厅、健身房、娱乐活动以及岸上观光），可能会限制或排除客人参加特定活动；（4）乘客出了舱房后在大部分区域都要求佩戴口罩（因医学问题无法佩戴口罩的除外），包括在船上以及登船、离船和岸上观光过程中；（5）在船上以及登船、离船和岸上观光过程中，要求保持社交距离；（6）根据当地要求对岸上观光活动可能会有额外限制和要求，包括但不限于在特定目的地限制离船（除非是参加承运人批准的岸上观光活动）；（7）乘客进入或离开公共区域强制消毒双手；（8）如出于防控新冠传播之目的，承运人认为有必要的情况下，可以要求乘客待在舱房内、进行隔离、或紧急离船；（9）乘客应签署承运人实施新冠相关政策和流程所必要的授权文件或同意书（包括但不限于健康信息、健康隐私、或个人信息隐私同意书）；以及（10）承运人出于新冠防控目的根据其自由裁量认为有必要采取的其他政策和流程。乘客同意：（i）新冠健康防护措施隐私政策（&ldquo;新冠防护隐私政策&rdquo;）是承运人新冠相关政策和流程不可分割的组成部分；（ii）新冠防护隐私政策已在网站对乘客进行公示（<a
                href="http://www.rcclchina.com.cn/"
                >http://www.rcclchina.com.cn/</a
              >）；（iii）乘客同意新冠防护隐私政策的条款。
            </p>
            <p>
              d. 强制遵守新冠相关政策和流程.
              不论本票据合同是否有其他规定，乘客或其同行人如未能遵守承运人的新冠相关政策和流程或本票据合同的，承运人有权拒绝登船、拒绝离船上岸后的再次登船、在游轮进行隔离、要求离船、向政府或卫生部门进行报告、或采取在该等情况下承运人认为出于保护其他乘客的健康和安全之目的而有必要采取的其他措施。在该等情况下，乘客不会获得退款或其他任何形式的补偿。乘客应负担所有必要的费用及罚款，包括但不限于为获得任何港口的旅行证件或为了离开或返回乘客居住国可能产生的出行费用。乘客因该等原因被拒绝登船、拒绝再次登船、隔离、离船或被承运人采取其他措施而可能产生的损失或费用，承运人不承担任何责任。
            </p>
            <p></p>
            <p><strong>5. 医疗护理和其它个人服务</strong></p>
            <p>
              a. 可提供的医疗护理服务.
              基于海上旅行的性质以及所访问港口的限制，游轮上及所停靠港口能够提供的医疗护理服务可能会有所限制或迟延；此外，承运人可能无法在游轮海上航行期间或在游轮航行过程中停靠的所有港口，为乘客提供紧急运送就医服务。
            </p>
            <p>
              b. 与服务提供商之间的关系.
              若乘客在船上或船下接受任何医护人员或独立合同方提供的医护服务，则所产生的一切风险均应由该乘客自行承担。承运人在船上或船下为本船乘客所安排的任何医护人员，均仅是为了便利乘客之目的而提供的，该等医护人员直接为乘客提供服务，不应被视为是在承运人的控制或监管下提供服务，因为承运人并非医疗服务提供商。同样的，本游轮、交通工具或其它地方的任何特许服务项目（包括但不限于礼品店、Spas、美容沙龙、艺术品展、摄影服务或正装特许经营店），均是独立合同方或由独立合同方承包商自行运营，提供该等服务仅是为乘客便利之目的。尽管承运人有权就上述服务的安排收取费用并获取收益，但上述所有人员或实体应被视为是独立合同方，而并非是作为承运人的代理人或代表行事。对于该等人员或实体所提供的任何医护服务、疏于提供医护服务、诊断、误诊、实际或被指控的治疗失当、建议、检查或其它服务，承运人均无需承担任何责任。乘客确认：本游轮上的美发化妆师、美甲师、艺术品拍卖人、礼品店工作人员、Spa工作人员、婚礼规划师及提供其它商品和个人服务的提供者均为独立合同方的员工，承运人无需对上述人员的任何行为承担任何责任。
            </p>
            <p>
              c. 医护服务或个人护理服务的付款.
              乘客应就其在船上或船下所要求或申请的任何医护服务或其它个人服务支付所有服务费用，上述服务费用包括由承运人垫付的任何紧急医疗护理费或交通费，以及为提供邮轮协会乘客权利法案规定的医疗服务而产生的任何费用。在乘客无力支付上述服务费且承运人代其支付了该服务费后，乘客应就该代付费用向承运人进行偿还。
            </p>
            <p></p>
            <p><strong>6. 岸上短途观光、观光游、设施或其它交通</strong></p>
            <p>
              由承运人为乘客安排的或乘客自行安排的在游轮巡游/游轮观光活动之前、之中或之后的任何交通服务（本游轮上的航行除外），以及任何的航空运输服务、岸上短途观光、观光游、酒店、餐馆、游览项目及其它类似活动或服务（包括所有相关的运输、产品或设施），均应视为是专为乘客的便利而提供的，且由乘客自行承担风险。上述服务、运输、产品和设施的提供商、所有人和承运人均为独立合同方，而并非作为承运人的代理人或代表行事。如本票据合同第4条或承运人网站上可能提示的，承运人的新冠相关政策和流程将会对岸上观光活动进行限制，如参与、所在地、时间、乘客可以接触的合适的场所及人员、乘客人数等。乘客理解并同意，承运人基于安全健康方面的考虑，可能会在停靠港禁止乘客下船上岸、或限制乘客上岸参加特定的活动或岸上观光。尽管承运人就其安排或提供以供乘客购买的岸上短途观光、观光游、酒店、餐馆、游览项目、陆地游项目及其他类似的在船下提供的盈利活动或服务，可能会收取费用或从中盈利，且要求其遵守承运人的新冠相关政策和流程，但承运人无义务对上述独立合同方或其员工的行为进行监督或控制，无义务提供运输工具或设施，也不就上述活动或服务的适当性或安全性做出任何明示或默示的声明。在任何情况下，若因上述任何独立合同方的任何行为、过失或过错之原因，而使乘客在船上、船下或上述交通工具上遭受了任何损失、延误、不满、损害、人身伤害、死亡或其它任何伤害，承运人均不应对此承担任何责任。为免疑惑，乘客从旅行代表处所购买的岸上短途观光或其他服务，应由其与该旅行代表所同意的条件和条款进行约束，承运人对于该等岸上短途观光或其他服务的履行过程中乘客所遭受的任何损失、延误、不满、损害、人身伤害、死亡或其他任何伤害，不承担任何责任。
            </p>
            <p>&nbsp;</p>
            <p><strong>7. 承运人所作的取消、变更或更换</strong></p>
            <p>
              a.
              承运人无法保证游轮会在每一个停靠港口停靠或完全按照预定行程进行航行。在起航前或起航后，行程可能会不时发生变更。尽管承运人始终会努力避免对行程进行任何变更或取消，在某些情况下，承运人可能需要将预定的起航时间、停靠港、目的港、客房或其它任何船上或船下活动予以取消、提前、延后或变更，或更换游轮、停靠港、目的港、客房或其它活动项目。可行的情况下，承运人会尽快尽合理努力将变更或取消通知乘客或其旅行代表。除第4.e、4.f、7.d和7.e款另有规定外，或因公共卫生紧急事件或政府命令导致游轮行程取消或延误乘客登船超过24小时以上且法律要求退款的，就上述任何取消、提前、延后、更换或变更行为，承运人均无需对乘客的任何索赔请求负责，包括但不限于损失、赔偿或退款。
            </p>
            <p>
              b.
              举例而言（不局限于此举例情形），若承运人认为发生了任何不利情形(如敌意行为、封锁、不利天气条件、劳资冲突、船上或岸上罢工、船体故障、阻塞、入港困难、医疗或人命救助紧急情况、确认全球性流行病、公共卫生紧急事件或传染性疾病爆发、隔离、国家或区域性紧急状态、或其它任何原因)从而可能导致航程、任何乘客或财产受到侵害或其它不利影响，则承运人有权改变预定航线和/或将乘客及其财产运至其它任何港口而不承担任何责任，本票据合同或适用法律另有规定的除外。
            </p>
            <p>
              c.
              对于由任何政府机关（或代表上述政府机关执行公务的人员）所做出的任何命令、建议或指示，承运人均有权予以遵守，且该遵守行为不构成承运人对本协议的违约，乘客也无权因此提出要求承运人承担任何责任、赔偿或退款的索赔请求。
            </p>
            <p>
              d.
              不可抗力事件也可能导致行程取消、变更或更换。&ldquo;不可抗力事件&rdquo;是指无法预见、避免和克服的事件，包括但不限于天灾、游轮故障、敌视行为、封锁、劳资冲突、船上或岸上罢工、政府扣押或管制、战争、火灾、冲突、保险公司指令、逮捕、政府机关或其它主管机关限制或命令、恐怖活动、民众骚乱、天气条件（包括台风）、以及有关游轮安全问题（船长是唯一裁断者）、游轮浸水或船体、机械部件及固定部件的故障或损坏（承运人经惯常及全面的机械检查仍不可预见或避免的情况）、无法保证或未能获取包括燃料在内的供给、游轮被征用、港口拥堵及堵塞、旅游目的地政府/世界卫生组织发出旅游警告、政府部门发出红色/黑色外游警示、确认全球性流行病、公共卫生紧急事件或传染性疾病爆发、隔离、国家或区域性紧急状态、其他业界不能控制的不利旅客外游的情况、或其它超出承运人控制范围的情况（包括但不限于因任何前述事件导致的承运人运力配置变更）。当不可抗力事件导致承运人做出任何取消、变更或更换时，应适用下述规定：
            </p>
            <p>
              d.1
              起航前，如果承运人因不可抗力事件被迫彻底取消游轮行程（行程的变更或停靠港口的更换不应被视为是行程的取消），承运人所需承担的唯一责任是在三十（30）天内，向乘客或其旅行代表（如果乘客是通过旅行代表订票的话）退还承运人所收取的订票费用。通过旅行代表订票的乘客请联系您的旅行代表有关退款事宜。
            </p>
            <p>
              d.2
              起航前，如果因为不可抗力事件需要变更行程且该等变更会对整体度假体验造成不利影响，则乘客应享有以下选择权:
              (i)
              接受变更后的行程安排，该等情况下，承运人将按照下述第7.d.3款在三十（30）天内向乘客或其旅行代表退还费用(如有)；(ii)取消行程，该等情况下，承运人将在三十（30）天内向乘客或其旅行代表退回承运人收取的订票费用的50%，港务税费，以及承运人收到的岸上短途观光费用的退款（如果岸上短途观光是通过承运人购买的话）。
            </p>
            <p>
              d.3
              如果乘客选择上述第7.d.2款下规定的第一种方案接受变更后的行程安排，则退款（如有）将按照如下规定由承运人退回给乘客或其旅行代表：(i)如果承运人认为不可抗力事件导致无法完成游轮行程而需要缩减行程天数，则承运人应根据游轮行程中被缩减的巡游天数占总巡游天数的比例，将收取的订票费用按比例退还给乘客或其旅行代表。为本条款之目的，每一巡游日应视为从当地时间上午
              12:01开始。若任何巡游在当地时间下午12:01之后取消，应当被视为该日整日的巡游活动已经完成。将游客送返至登船港口途中的时间应被包括在巡游时间内，承运人应向乘客提供游轮上的所有服务和住宿。(ii)
              如果起航延误、港口停靠时间缩短或返回目的港延误，但行程天数不减少，则承运人无需承担赔偿或退款的任何责任，而船上将向乘客提供各项服务和住宿。(iii)如果停靠港口被取消或更换且因为该等取消或更换使得承运人收到了港务税费及/或岸上短途观光费用（如果岸上短途观光是通过承运人购买的话）的任何退款，则承运人应将该等退款退回至乘客或其旅行代表。
            </p>
            <p>
              d.
              4游轮行程开始后，如果因不可抗力事件需要进行任何行程变更或更换，承运人需要承担的唯一责任为:
              (i)如承运人因该等变更获得任何港务税费及/或岸上短途观光费用（如果岸上短途观光是通过承运人购买的话）的退款，则承运人应将该等退款退回给乘客或其旅行代表；及/或(ii)游轮行程被缩减的情况下，根据游轮行程被缩减的巡游天数所占总行程巡游天数的比例，向乘客或其旅行代表按比例退还收取的订票费用。退款应在游轮行程结束后三十（30）天内进行。
            </p>
            <p>
              e.
              如果因为机械故障导致游轮巡游（或游轮观光中的游轮巡游部分）被取消或提前终止，则(i)若游轮巡游被完全取消，乘客享有巡游费用全额退款的权利；若游轮巡游被提前终止，则享受部分退款；(ii)承运人可在其认为适当的范围内承担或补偿乘客的额外费用（如机票改签费用）；(iii)
              若乘客已到达游轮，乘客有权享有交通服务（按照乘客选择的交通方式）将其送至游轮预定的到达港或乘客所属城市；并且(iv)若因游轮巡游或游轮观光中的游轮巡游部分被取消或提前终止导致乘客需要在非预定港口下船并过夜，则乘客有权享有游轮公司选择安排的住宿服务。
            </p>
            <p>
              f.
              乘客代表自己及其他所有在本票据合同项下的游客（包括但不限于随行未成年人及其他本合同项下的同行客人）同意，若其对于行程变更有任何疑惑、问题或纠纷，应通过适当且合法的方式解决。在任何情况下，乘客都不得参与船上的示威游行、抗议或其它承运人视为将会对船上气氛、其他乘客的游轮旅游享受造成不利影响的行为。乘客不得通过拒绝登船或离船的方式胁迫承运人承担任何责任，或干扰游轮的运营或航行，或通过极端的方式进行抗议（如静坐抗议、在游轮公共区域聚集、唆使其他游客加入抗议活动等），或采取其它违反乘客行为守则以及游轮航行所涉及的国家的法律法规的行为。乘客应始终遵守游轮船长的通知，并遵守承运人的乘客行为守则。若乘客未能遵守本条款之规定，可能导致承运人根据乘客行为守则采取措施，并要求乘客就其行为可能给承运人造成的损失承担责任。
            </p>
            <p></p>
            <p><strong>8. 乘客所做之取消或提前离船</strong></p>
            <p>
              a.
              如果乘客是通过旅行代表订票的，则您的游轮巡游或游轮观光费用，包括但不限于任何燃料或其他附加收费、政府税费和其他收费均是为您订票的旅行代表所设定的，而不是承运人。同样，您的游轮或游轮观光费用付款时间表，均是您订票的旅行代表所设定的，而不是承运人。此外，所有针对您的游轮或游轮观光费用的取消和退款政策均是为您订票的旅行代表所设定，而不是承运人。如果乘客是通过旅行代表订票的，则有关游轮巡游或游轮观光费用的任何款项应当向该旅行代表支付，而不是向承运人支付。如果承运人收到来自您的旅行代表的付款，则除非承运人和旅行代表另有约定，退款将退回至该旅行代表处。
            </p>
            <p>
              游轮巡游或游轮观光开始之前或开始后，任何因乘客取消行程而导致的退款应由为您订票的旅行代表确定和决定，且若需要退款的话，退款的责任应由该旅行代表独立承担。若因任何原因（包括按照本票据合同规定）乘客在游轮巡游开始前取消行程或提前离船，该等情况下承运人不需要退款、赔偿或承担任何责任。
            </p>
            <p>
              b.
              如果乘客通过承运人或其指定的当地关联公司（下称&ldquo;承运人订票机构&rdquo;）订票，则乘客的该等预订（包括但不限于其游轮巡游或游轮观光的费用、付款要求、取消及退款政策）都应受承运人订票机构的条款及条件约束，具体如下：
            </p>
            <p>
              (1)
              特定价格政策（如早订特惠价）将要求在预订时即支付一笔不可退的订金。与常规优惠价政策不同的是，该等订金支付后在任何时间内都是不可退的。该等订金不可退的预订在适用情况下也会收取更改费用。而常规优惠价政策下，如果起航前取消游轮巡游可能会收取取消费用。取消费用的金额根据承运人订票机构收到乘客取消通知之日距离起航日的远近而有所不同。
            </p>
            <table>
              <tbody>
                <tr>
                  <td width="170">
                    <p>取消时间</p>
                  </td>
                  <td width="216">
                    <p>常规优惠价政策的取消费用</p>
                  </td>
                  <td width="216">
                    <p>特定价格政策的取消费用</p>
                  </td>
                </tr>
                <tr>
                  <td width="170">
                    <p>起航日前46天或更早</p>
                  </td>
                  <td width="216">
                    <p>不收取取消费用</p>
                  </td>
                  <td width="216">
                    <p>人民币1,000元/人</p>
                  </td>
                </tr>
                <tr>
                  <td width="170">
                    <p>起航日前45至30天</p>
                  </td>
                  <td width="216">
                    <p>人民币1,000元/人</p>
                  </td>
                  <td width="216">
                    <p>人民币1,000元/人</p>
                  </td>
                </tr>
                <tr>
                  <td width="170">
                    <p>起航日前29至8天</p>
                  </td>
                  <td width="216">
                    <p>船票费用的50%（不含港务税费）</p>
                  </td>
                  <td width="216">
                    <p>船票费用的50%（不含港务税费）</p>
                  </td>
                </tr>
                <tr>
                  <td width="170">
                    <p>起航日前7天或以内</p>
                  </td>
                  <td width="216">
                    <p>船票费用的100%（不含港务税费）</p>
                  </td>
                  <td width="216">
                    <p>船票费用的100%（不含港务税费）</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              (2)
              在中国境外所做的预订或以美金支付的非中国母港航线的预订，可能适用不同的取消政策。请联系你的预订机构或旅行代表进行确认。
            </p>
            <p>
              (3)
              乘客在游轮巡游开始后取消行程、或因任何原因提前离船（包括按照本票据合同规定）、或未登船，则该等情况下承运人订票机构不需要退款、赔偿或承担任何责任。
            </p>
            <p>
              (4)
              承运人订票机构保留推出促销游轮票价或其他优惠价格的权利，该等活动的取消政策可能也会有所不同。具体请参见订票时适用的条款及条件。
            </p>
            <p>
              c.
              乘客承认，对某些航行，如从美国港口开始的一个往返航程，乘客必须完成整个的航程，如不这样做可能会导致一个或多个政府机构作出罚款或其他处罚。若乘客未能完成整个航程，乘客在此同意支付任何该等罚款或处罚，若承运人为此支付了罚款或处罚，则乘客应赔偿承运人该等费用。
            </p>
            <p></p>
            <p>
              <strong
                >9.
                乘客遵守本协议、相关法律及承运人制度之义务；检疫；赔偿</strong
              >
            </p>
            <p>
              a. 一般守法义务.
              在任何时间，乘客均需遵守本协议规定、所有适用法律以及承运人、游轮及其它交通工具的规章、政策和规定（该等规章、政策和规定可能经或不经通知而不时变更）、以及本协议第4条和承运人网站（<a
                href="http://www.rcclchina.com.cn/"
                >http://www.rcclchina.com.cn/</a
              >）公布的新冠相关政策和流程。乘客同意：在任何情况下，其均不得进入本游轮上指定船员专用的任何区域，比如船员住宿区。乘客进一步同意，承运人有权禁止或限制乘客将任何酒精饮料携带上船使用，并同意遵守承运人就上述事项所制定的任何政策之规定。本协议中任何规定都不能视为授予乘客在游轮巡游或游轮观光期间向其他乘客销售产品或提供服务的权利，乘客的上述行为是被禁止的。
            </p>
            <p>
              b.
              乘客应独自负责取得并持有在任何停靠港登船、旅游或离船所需的护照、签证及其它旅行证件。乘客应承担完全的责任通过其旅行代理或适当的政府部门确认所需旅行证件。乘客同意：在承运人提出合理要求的情况下，乘客需向承运人提交任何相关旅行证件，但在巡游结束前，承运人应将上述旅行证件退还乘客。
            </p>
            <p>
              c.
              乘客理解并同意：承运人的政策不允许乘客做出任何违法行为，且一旦出现任何上述违法行为，承运人将依法向相关机关报告。
            </p>
            <p>
              d.
              每一成年乘客均保证并同意：在任何时候，其均应对任何随行的未成年人尽到监督职责，以确保遵守本第9条之规定。
            </p>
            <p>
              e.
              若基于承运人或船长的独立判断，任何乘客或由其负责监护的任何未成年人乘客的行为或活动被认为造成潜在危险、安全风险或对其自身或其他乘客的健康、安全、舒适或愉悦体验产生不利影响、违反了承运人的新冠相关政策和流程、或违反了本协议的任何条款，则承运人有权变更该等乘客的住宿、更改或取消其活动、拒绝提供任何酒精饮料服务、将其限制在舱房或隔离、检查其舱房、财产或行李、变更其陆地游活动、要求其及/或负责监护未成年人的乘客下船或拒绝他们登船、或在任何时候对其进行约束；对此，承运人无需承担任何责任，而乘客须承担该等风险及费用。
            </p>
            <p>
              f.
              若因任何乘客的行为或因其未能遵守本第9条之规定（包括但不限于下述情形：(i)乘客所购买的任何服务超出了乘客的支付能力而未予付款；(ii)乘客未能遵守与入境、海关或消费税相关的要求（例如，非法滞留在停靠港口而未能在规定登船时间返回游轮）；(iii)
              因乘客的故意不当行为、过失行为或不作为而直接或间接地、全部或部分地导致出现了任何人身伤害、死亡或财产损失）；或（iv）乘客未能遵守承运人的新冠相关政策和流程，从而导致承运人、游轮或交通工具遭受了任何民事责任、罚金、罚款、费用或开支，则该乘客（若为未成年人乘客，则其父母或监护人）应对此予以负责，并应当向承运人、游轮或交通工具给予相应的赔偿。
            </p>
            <p>
              g.
              无论基于何种原因，就某特定游轮巡游或游轮观光项目，若在船只或任何运输工具规定的登船或上车时间内，任何乘客未能登船或上车；或在任何停靠港、目的港或开航港规定的启航开船时间前，任何乘客未能顺利回船，则承运人均无需对上述游客所缴纳的任何游轮巡游/游轮观光费用进行退款，也无需对上述游客因此而产生的任何住宿费、餐饮费、交通费或其它任何费用负责。游轮在任何停靠港、目的港或开航港的开船起航时间详见相关游轮巡游/游轮观光活动的公告。
            </p>
            <p>
              h.
              在任何时候，若为下述之任何理由，承运人均有权拒载任何乘客，或有权将任何乘客驱逐出游轮或其它交通工具：(i)
              该等拒载或驱逐是为了符合任何政府规章、指令或指示所需；(ii)
              上述乘客拒绝承运人对其人身或财产进行搜查以确定是否有任何爆炸物、武器、危险物品或其它盗窃物品、非法物品或管制物品；(iii)
              在承运人已提出请求的情况下，上述乘客拒绝向承运人提供有效身份证明；或者(iv)
              乘客未能遵守承运人规章和程序之规定，包括如承运人的乘客健康、安全和行为政策及承运人关于禁止与船上工作人员过密接触的政策；
              (v)根据承运人的拒绝承运政策而拒绝承载乘客；或（vi）乘客未能遵守承运人的新冠相关政策和流程。上述承运人的乘客健康、安全和行为政策和拒绝承运政策也可在以下网址查阅：
              <a href="http://www.rcclchina.com.cn/"
                >http://www.rcclchina.com.cn/</a
              >。
            </p>
            <p>
              i.
              为旅行安全和保障之需，无论是否乘客已同意或知情，承运人均将对乘客及其行李进行电子检查或监督。
            </p>
            <p>
              j.
              若承运人行使了本第9条中规定的任何权利，则乘客无权因此向承运人提出任何索赔请求；此外，承运人也无需对乘客进行任何退款或赔偿乘客因此而遭受的任何损失或损害，包括但不限于乘客因食宿或被遣返回国而产生的任何费用。
            </p>
            <p>&nbsp;</p>
            <p><strong>10. 人身伤害/疾病/死亡索赔</strong></p>
            <p>
              a.
              <strong
                >关于人身伤害、疾病或死亡的索赔请求，乘客和承运人均同意：因本协议或乘客的游轮巡游/游轮观光活动、陆地游活动或乘坐的任何交通工具之原因而产生的或与此相关的任何纠纷或争议，均需通过诉讼方式解决，且该等纠纷或争议应被提交至位于中国上海的相关法院进行诉讼。乘客在此同意上述法院的管辖权，并放弃对于其需在中国上海相关法院提起诉讼或诉讼程序的任何管辖异议或其他异议。</strong
              >
            </p>
            <p>
              b.
              <strong
                >人身伤害/疾病/死亡索赔请求的时效规定：
                无论法律是否另有规定，若任何乘客因游轮巡游/游轮观光活动遭受任何人身伤害、疾病或死亡，则该等索赔请求的书面通知（连同全部详细信息）应在上述人身伤害、疾病或死亡发生之日起的六个月期间内递送至承运人的主营地址，诉讼应在该等人身伤害、疾病或死亡之日起的两年期间内启动（受理），且该诉讼的程序送达文件已在上述诉讼受理之日起的120日内送达至承运人；否则乘客将无权就上述人身伤害、疾病或死亡向承运人提起任何诉讼。</strong
              >
            </p>
            <p>
              c.
              <strong
                >放弃集团诉讼救济权利.
                乘客在此同意：乘客均仅能以其个人身份就其个人相关索赔请求向承运人提起诉讼。除非相关法律另有其它规定，乘客同意：对于其就承运人、船只或任何交通工具而提起的任何仲裁请求或诉讼请求，其都仅能单独提起，并不得作为任何集团诉讼或代表人诉讼的成员或部分而参诉；并且，乘客还明确同意放弃任何法律中授予其参加集团诉讼的权利。若您的索赔请求应按照下述第11.b条的规定进行仲裁，则仲裁员将无权审理以集团诉讼方式提起的索赔请求。乘客同意，在任何情况下，本款之规定均不得与下述第11.b条中规定的仲裁条款相分割开来。</strong
              >
            </p>
            <p></p>
            <p><strong>11. 除人身伤害/疾病/死亡外的其他索赔</strong></p>
            <p>
              <strong
                >a.
                其它所有索赔请求的仲裁解决：除上述人身伤害、疾病或死亡的纠纷、索赔请求或争议外，对于任何其它纠纷、索赔请求或争议而言，无论其是基于合同关系、侵权、法定、宪法或其它法定权利而产生的，包括但不限于乘客所诉的对其民事权利、平等待遇、消费者权利或隐私的侵犯而产生的任何纠纷、索赔请求或争议，以及因本合同或游轮巡游而产生或与此相关的任何关于损失、损害或费用的任何纠纷、索赔请求或争议（无论其是以何种方式描述、提出或修辞），均应当且仅应当提交中国国际经济贸易仲裁委员会（下称&ldquo;贸仲委&rdquo;）并依据仲裁申请时贸仲委现行有效的仲裁规则（下称&ldquo;规则&rdquo;）进行终局性并具有约束力的仲裁裁决。该等规则通过引述被视为本条款的组成部分且可以被本条款的其他部分所修正。仲裁地点为上海，仲裁程序可以以中英文进行。仲裁庭（下称&ldquo;仲裁庭&rdquo;）应由三（3）名仲裁员组成。双方应各自指定一（1）名仲裁员。两（2）名已选定的仲裁员应指定第三名仲裁员担任首席仲裁员。如果一方未能在另一方要求其指定仲裁员后十五(15)个工作日内指定，或在确认对第二名仲裁员的指定后十五(15)个工作日内，两（2）名仲裁员无法指定第三名仲裁员，应由贸仲委主任应任何一方的要求根据规则指定该仲裁员。仲裁庭的任何裁决都应以书面形式作出，且自作出之日起应是终局的并且对双方有约束力的。</strong
              >
            </p>
            <p>
              <strong
                >b.
                非人身伤害/疾病或死亡索赔请求的时效规定：对于上述第11.a条中规定的就承运人、游轮或交通工具所提起的仲裁程序，除非在与该乘客的票据合同所涉游轮巡游/游轮观光终止之日（以较晚者为准）起的六个月内，索赔请求的书面通知（连同全部详细信息）已递送至承运人主营地址，否则该乘客将无权提起上述仲裁程序。在任何情况下，无论法律是否另有其它规定，除非在与该乘客的票据合同所涉游轮巡游/游轮观光结束之日（以较晚者为准）起的一年内，上述第11.a条中规定的仲裁程序已启动（受理），且在上述仲裁程序提起之日起的六十日内，该等仲裁程序的有效通知或程序送达文件已生效，否则乘客所提起的第11.a条规定的任何仲裁程序均不应被支持。</strong
              >
            </p>
            <p>
              <strong
                >c.
                若游轮被扣押，乘客在此不可撤销地同意：承运人的任何保险人出具的担保函应构成被扣押或留置的船只将被即刻解除扣押或留置的适当并充分的担保。</strong
              >
            </p>
            <p>&nbsp;</p>
            <p><strong>12. 责任限制</strong></p>
            <p>
              <strong
                >a.
                除本协议另有明确规定外，因发生不可抗力事件或其它超出承运人合理控制范围的原因或其它任何并非因承运人过失而导致的事件，从而导致任何乘客出现了人身伤害、死亡、疾病、损害、迟延或其它个人或财产的损失、或其它任何索赔损失，承运人均无需承担责任。</strong
              >
            </p>
            <p>
              <strong
                >b.
                乘客同意：对于因乘客使用任何健身或娱乐设备或因任何独立合同方（包括但不限于摄影师、SPA工作人员或其它演艺人员）的过失或过错行为而产生的人身伤害、死亡、疾病或其它损失，或因承运人的游轮、航行或运输行为之外的其它原因，或因任何岸上短途观光、陆地游或其它活动而产生的人身伤害、死亡、疾病或其它损失，均应由乘客自行承担风险，且承运人均无需对上述人身伤害、死亡、疾病或其它损失负责。</strong
              >
            </p>
            <p>
              <strong
                >c.
                在任何情况下，对于乘客所遭受的任何种类的精神损害、精神痛苦或心理伤害，若其并非由于对乘客的身体伤害所致，或并非由于乘客曾经处于可能发生身体伤害的实际风险中所致，或其并非是由承运人故意行为所致，则承运人均不向乘客承担任何责任。在不限制上述规定的前提下，在任何情形下，承运人均无需承担任何间接、附带、惩罚性及惩戒性的损害赔偿责任。</strong
              >
            </p>
            <p>
              <strong
                >d.
                对于不在美国任何港口登船、离船或停靠的游轮巡游而言，承运人均有权根据《1974年海上旅客及其行李运输雅典公约》及《1974年海上旅客及其行李运输雅典公约的1976年议定书》及其修订案（如适用）（以下合称&ldquo;雅典公约&rdquo;）之规定，享有所有责任限制、责任豁免及其它相关权利。根据雅典公约之规定，承运人就人身伤害或死亡所承担的最大责任限额为46,666个特别提款权赔偿（按照公约之定义，大约为$70,000美元，该金额随华尔街日报登印的每日汇率而波动）。此外，美国法律（包括美国法典第46章第30501条至第30509条以及第30511条）规定或授予的所有责任限制或责任豁免也应适用，且这一规定同样适用于任何其他游轮巡游。</strong
              >
            </p>
            <p></p>
            <p><strong>13. 健康状况适于旅行；拒绝登船；未成年人</strong></p>
            <p>
              a.
              乘客保证：其和随其旅行的其他人员的身体情况均适合旅行，且该旅行不会对其或他人产生任何危险。
            </p>
            <p>
              b. 未成年人.
              任何18周岁以下的乘客均视为是未成年人，其应当跟随其父母、法定监护人或承运人政策允许的其它人员参与该旅行。
            </p>
            <p>
              c.
              从北美出发的巡游，出行最低年龄要求为21周岁。从欧洲、亚洲、南美、新西兰及澳洲出发的巡游，出行最低年龄要求为18周岁。乘客在整个游轮度假行程中的年龄确定以其在起航日的年龄为准。承运人保留在任何时候要求乘客提供年龄证明的权利。未满足年龄要求的乘客不得被预订在一间单独的舱房，除非同房间内有符合年龄要求的成年人陪同。然而，若未成年人与其父母或法定监护人一起出行，且未成年人住在其父母或法定监护人的隔壁或对面客房，则未成年人可单独入住。该等情况下，允许该父母或法定监护人安排同等数量的其他无法定监护关系的未成年人与该未成年人同住。（举例：如果父母住在隔壁或对面客房，则其未成年子女可以带1位未成年朋友同住，2位未成年子女可以带2位未成年朋友同住。）
            </p>
            <p>
              &nbsp; &nbsp;
              前述政策的例外是针对已婚夫妇的情形：已婚夫妇可以同舱房一起出行而无需满足超过18/21周岁的年龄要求，但应事先提供已婚证明。
            </p>
            <p>
              d. 孕妇和婴儿.
              在任何情况下，在游轮巡游/游轮观光活动开始之日或其后行程的任何时间里妊娠将进入第24周或以上的乘客，不得预定游轮巡游或登船或乘坐任何交通工具。任何情况下，特定年龄以下的婴儿（大部分游轮巡游要求婴儿的最低年龄在六个月以上；而其它游轮巡游，如跨大西洋航线、跨太平洋航线、有三个以上连续航海日以致医疗救助受限的行程、或者行程将去Amazon,
              Greenland,
              Antarctica等较远的地区，可能要求婴儿的最低年龄在十二个月以上），不得为其预定游轮巡游/游轮观光活动，或被任何乘客带到游轮或其他交通工具上。若需了解最新的年龄限定要求，可登陆<a
                href="http://www.royalcaribbean.com"
                >www.royalcaribbean.com</a
              >查询。
            </p>
            <p>
              e. 特殊要求.
              若任何乘客在行动、沟通或其他方面存在障碍，或存在其他特殊或医疗需求可能需要在游轮巡游/游轮观光活动中提供医疗护理或特殊住宿安排，包括但不限于使用任何服务类动物，乘客应在预定游轮之时告知承运人。乘客同意，若因乘客将任何服务类动物带上游轮或其它运输工具之原因，使得承运人遭受了任何损失、损害或费用，则乘客应承担所有责任，并向承运人进行完全赔偿。乘客确认并理解：根据相关国际安全要求、造船业标准和/或其它应适用的与游轮的设计、建造或运行相关的规定，在行动、沟通或其他方面存在障碍或有特殊需求的乘客在使用一些设施或参加一些活动时将受到限制。由于游轮上的轮椅只供紧急状况下使用，对于有轮椅使用需求的乘客，其应自行携带轮椅，且该轮椅的大小和类型应适合于在游轮上使用。
            </p>
            <p>
              f.
              对于任何违反本款政策规定的乘客，承运人均有权拒绝其登船。若承运人行使了第4条和本第13条中规定的权利，则乘客将无权向承运人提起任何索赔请求，且承运人也不向乘客承担任何退款、赔偿损失或损害的责任，包括但不限于乘客因食宿或被遣返回国而产生的任何费用。
            </p>
            <p>
              g. 水上玩乐设施.
              我们的水上玩乐设施没有配备救生员。在泳池、旋涡池及其他水上娱乐设施时，小孩应始终由其父母或法定监护人看护。
            </p>
            <p>
              h. 饮酒规定.
              全船政策：乘客在皇家加勒比国际游轮上允许消费酒精饮料的最小年龄取决于航程起始时游轮的所在地。从欧洲、亚洲、澳大利亚、新西兰和南美洲出发的游轮，最小饮酒年龄为18周岁。从北美洲出发的游轮，最小饮酒年龄为21周岁。在专属海滨度假区如拉巴地和可可岛以及在美国的港口时，最小饮酒年龄为21周岁。承运人保留在当地法律要求下或在认为合适或者必要的情况下，可不经预先通知而改变最小饮酒年龄的权利。如果低于最小饮酒年龄的客人在航程中度过生日并达到最小饮酒年龄，客人必须通知客户关系服务台，并且提供护照作为证明年纪的证据，以使客户关系服务台的工作人员更新他们的信息并允许他们在船上购买酒精饮料。
            </p>
            <p></p>
            <p><strong>14. 船上活动风险告知和确认</strong></p>
            <p>
              乘客确认其在参加各项船上活动之前，应仔细阅读相关的活动规则和说明，并知悉参与该等活动的要求、限制以及可能产生的风险。参与任何船上活动都是基于自愿原则。乘客知悉并同意，其自愿参加的活动可能存在一定风险，其应仔细阅读活动的安全警告，在知悉相关规则和风险情况下自行决定自己或其看护下的未成年人是否参与该等活动。
            </p>
            <p></p>
            <p><strong>15. 照片、视频或音频资料的使用</strong></p>
            <p>
              乘客在此授予承运人（及其受让人和被许可人）全球性、永久性且专属性的权利，将在本次游轮巡游/游轮观光活动期间或与之相关的活动中所拍摄/录制的乘客的任何照片、视频资料、音频资料及其它任何视频音频图片（包括形象、肖像或声音），用于任何性质的任何媒质中（包括对这些资料所作的编辑、将之与其他材料合成或创造任何形式的衍生作品），用于交易、广告、销售、产品展示、推广、培训或其它任何相关目的，而无需向乘客支付费用。上述授权范围包括对存储在任何媒质（包括但不限于因特网）中的图片、形象、影像、磁带、图画或音频资料进行复制、修改、分发、展示和销售等的无限制权利。乘客在此同意：该等资料之所有权利、所有权和权益（包括其在全球任何地方所享有的版权）均属于承运人的独有财产，乘客或其它从乘客处取得相关权利或权益的任何他人均无权提出任何权利请求。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;
              乘客在此同意：在未获承运人明确书面同意的情况下，由船上的乘客、其他乘客、船员或第三方当事人在游轮上所制作的或以他们为对象制作的，或描绘游轮及其设计、装备或其他内容的任何记录资料（不论是音频、视频或其它形式）或图片，均不得用于任何商业目的，不得用于媒体广播，也不得用于其它非私人用途。承运人应有权采取任何合理措施以执行本条款。
            </p>
            <p><br /><strong>16. 您的旅行代表</strong></p>
            <p>
              乘客承认并确认：乘客为此票据合同之相关预定而使用的任何旅行代表应为乘客的代表人，承运人均无需对上述旅行代表所作的任何声明负责。乘客理解并同意：一旦旅行代表收到本票据合同或其它任何信息或通知，均视为已在旅行代表收讫的相同日期为乘客所接收。乘客承认承运人无需对任何旅行代表的财务状况或诚信度承担任何责任。
            </p>
            <p></p>
            <p><strong>17. 可分性</strong></p>
            <p>
              无论基于何种原因，若本协议的任何条款在任何管辖权下被认定为不可执行，则均视为该相应条款已在上述管辖权下从本协议分割出去，且本协议其它条款将继续保持充分效力。
            </p>
            <p>&nbsp;</p>
            <p><strong>18. 转让和让与</strong></p>
            <p>
              本票据合同不具有可转让性。除其它含义外，&ldquo;不具有可转让性&rdquo;意味着乘客不得将本票据合同销售或转让给其它任何人；在任何他人出具本票据合同的情况下，承运人将无义务向乘客或持有本票据合同的任何他人确认履行本票据合同或进行退款。
            </p>
            <p>&nbsp;</p>
            <p><strong>19. 与其它采购行为的关系</strong></p>
            <p>
              在法律规定或允许的最大范围内，本协议同时涵盖承运人的游轮保障产品、岸上短途观光、陆上及酒店服务套餐（如有）。
            </p>
            <p>&nbsp;</p>
            <p><strong>20. 适用法律</strong></p>
            <p>本乘客票据合同应当受中国法律管辖并依照其解释。</p>
            <p>&nbsp;</p>
            <p><strong>21. 承运人</strong></p>
            <p>
              根据您的具体航次，皇家加勒比国际游轮的运营者可能是下述实体之一：
            </p>
            <p>
              Royal Caribbean Cruises Ltd.（皇家加勒比游轮有限公司）： 1050
              Caribbean Way, Miami, Florida 33132
            </p>
            <p>
              RCL Cruises Ltd. （RCL游轮有限公司）： 7 The Heights,
              Brooklands, Weybridge, Surrey, KT13 0XW, United Kingdom
            </p>
            <p>
              RCL Cruises (Cyprus) Ltd.(RCL游轮（塞浦路斯）有限公司): Neocleous House, 195 Makarios III Avenue, 1-5th, Limassol, CY-3030 Cyprus
            </p>
            <p></p>
            <p style="text-align: center"><strong>拒绝承运政策</strong></p>
            <p style="text-align: center">
              <strong>皇家加勒比集团</strong><br /><strong>
                （更新时间：2020 年 11 月 20日）</strong
              >
            </p>
            <p>&nbsp;</p>
            <p>
              本拒绝承运政策（以下简称本&ldquo;政策&rdquo;）旨在帮助确保所有乘客都能有个安全、有保障且愉快的游轮假期。本政策非穷尽性地列举了皇家加勒比国际游轮、名人游轮、银海游轮和精钻会游轮（在此统称为&ldquo;皇家加勒比集团&rdquo;、&ldquo;游轮公司&rdquo;、&ldquo;我们的&rdquo;或&ldquo;我们&rdquo;）可能（i）拒绝承运乘客，及(ii)
              将乘客驱逐出游轮、其他交通工具或住宿（包括我们的私属目的地）的一些情形，并写明了该等流程。
            </p>
            <p>
              本政策的条款于前述日期生效，并将保持完全效力，除非我们自行决定更新或修改政策的全部或部分内容。本政策可能会进行更新或修改，该等更新或修改可不经公布而生效，但我们会尽力及时将政策的任何更新或修改发布至公开渠道，包括但不限于，皇家加勒比集团各网站或手机应用程序。
            </p>
            <p>
              <strong
                >有传染性疾病（如COVID-19&nbsp;）症状的乘客或其健康检查结果使我们相信其目前可能是传染性疾病携带者的乘客可能会被拒绝登船。此外，与确诊或疑似感染任何传染性疾病的人（包括其他乘客或船员）有密切接触的乘客，也可能会被拒绝登船。</strong
              >
            </p>
            <p>
              <strong
                >请注意，当我们拒绝承运未成年人及/或将其驱逐出游轮时，该等拒绝承运及驱逐的权利应同时适用于该等未成年人和负责监护的所有成年人。</strong
              >
            </p>
            <p>
              <strong
                >本政策不影响船长根据国内法或国际法赋予的最高权力而做出和执行基于船长独立专业判断认为系保持船舶安全和保障所必要的决策。&nbsp;
                &nbsp;</strong
              >
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center"><strong>本政策的执行</strong></p>
            <p>&nbsp;</p>
            <p>
              如果我们拒绝承运乘客或者将乘客驱逐出游轮、其他交通工具或住宿（包括我们的私属目的地），该行动可能会伴随以下一个或多个执行措施：
            </p>
            <ul class="leftPoint">
              <li>安保人员、其他管理人员或执法部门实施的执行措施;</li>
              <li>向主管政府当局和执法机关报告；</li>
              <li>
                取消某些船上特权，其中可能包括被拘留、隔离或限制在舱房内或隔离房间内；
              </li>
              <li>没收非法或违禁物品，基于我们的判断可将其移交至执法机关;</li>
              <li>拒绝登船或驱逐出游轮；</li>
              <li>拒绝其登上皇家加勒比集团未来任何游轮。</li>
            </ul>
            <p>
              <strong
                >我们拒绝承运乘客或者将其驱逐出游轮、交通工具或私属目的地的决定，将由我们自行裁量并将是最终决定。</strong
              >
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center">
              <strong>拒绝承运或驱逐出游轮的后果</strong>
            </p>
            <p style="text-align: left">
              <strong>乘客应自行承担驱逐相关费用</strong>
            </p>
            <p>
              被皇家加勒比集团拒绝承运或被驱逐出游轮的乘客应自行承担与拒绝承运或被驱逐有关的所有费用，包括但不限于任何的住宿和交通费用。回到乘客本国所需的任何文件也应由乘客自行负责。
            </p>
            <p>&nbsp;</p>
            <p><strong>有限追索权</strong></p>
            <p>
              在法律允许的最大限度内，依照本政策被驱逐出游轮或被拒绝承运的乘客，仅享有所适用的乘客票据合同或预订条款中所列明的追索权（如有）。
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center">
              <strong>拒绝承运或驱逐出游轮或私属目的地的非穷尽理由清单</strong>
            </p>
            <p>
              &nbsp;我们可能会，基于我们的自由裁量，在任何时候基于如下任何理由拒绝承运任何乘客或将乘客驱逐出游轮、其他交通工具或住宿（&ldquo;拒绝承运&rdquo;）。如下理由仅作为代表性的例子而非穷尽性列举，且不应限制：（a）我们执行本政策的权限或能力，（b）航行之前、期间或之后适用的司法管辖区权力，或
              (c) 船长根据国际法所享有的最高权力：
            </p>
            <p>
              <strong>1. 政府要求或规定。</strong
              >当拒绝承运是为了遵守任何政府规定、指令或指示，或为了遵守政府基于国防需要而提出的紧急运输要求或政府关于公共紧急状态的命令或声明。
            </p>
            <p>
              <strong>2. 不遵守法律。</strong
              >如果乘客未能或拒绝遵守任何法律、政府命令或法规，包括我们的游轮在航行期间访问的各个国家/地区的所有适用法律、政府命令或法规，则其可能被拒绝承运。
            </p>
            <p>
              <strong>3. 不可抗力。</strong
              >如发生恶劣天气或其他任何超出我们控制范围之事件（包括但不限于：天灾，流行病或大流行病，对乘客、其他乘客或船员的健康、安全或安保的构成威胁，罢工，民事骚乱，禁运，战争，敌对行动，干扰，或适用的乘客票据合同中详述的任何其他不可抗力事件），不论该事件为实际已经发生、威胁或据称将要发生，则承运人有权拒绝承运。
            </p>
            <p>
              <strong>4. 拒绝搜查乘客或财物。</strong
              >当乘客拒绝承运人为搜索任何爆炸物、武器、危险物品或其它偷窃、非法或违禁物品而对其人身或财产进行搜查时，则承运人有权拒绝承运。
            </p>
            <p>
              <strong>5.</strong>
              <strong>无法提供身份证明。</strong
              >在承运人已提出请求的情况下，乘客拒绝或无法向承运人提供有效的身份证明，则承运人有权拒绝承运。
            </p>
            <p>
              <strong>6. 未能出示必要的旅行证件。</strong
              >当乘客将穿越任何国际边界时，并且 (1)
              该乘客的旅行证件不齐备，或（2）该等运输可能构成违法，则承运人有权拒绝承运。
            </p>
            <p>
              <strong>7. 不遵守游轮公司的规则或政策。</strong
              >如果乘客不遵守或拒绝遵守我们的任何规则、政策和流程，包括但不限于，通过引用并入本政策的皇家加勒比集团之乘客健康、安全和行为政策，则承运人有权拒绝承运。
            </p>
            <p>
              <strong>8. 不遵守船上工作人员指示。</strong
              >如果乘客试图干扰任何船员履行其职责，或乘客不服从船长或其他船员的指令，则承运人有权拒绝承运。
            </p>
            <p>
              <strong>9. 不遵守游轮公司的乘客票据合同。</strong
              >如果基于我们的自由裁量，我们确定乘客可能违反适用的乘客票据合同条款，或当乘客的行为或出行本身违反适用的乘客票据合同条款，则承运人有权拒绝承运。举例说明，这包括但不限于，不符合乘客票据合同关于最低年龄限制的要求。
            </p>
            <p>
              <strong>10. 不当的乘客行为。</strong
              >当我们确定乘客的行为是扰乱治安的、侮辱性的或暴力的，或当乘客的行为可能会危害到其自身、船员或其他乘客，则承运人有权拒绝承运。如果乘客在船上试图出售或宣传产品或服务，或者在船上试图或参加示威、抗议或其他行为，且该等行为游轮公司认为影响船上氛围、其他乘客的游轮体验、或违反游轮公司、特许经营商或船上供应商的权利或期望，则承运人有权拒绝承运。
            </p>
            <p>
              <strong>11. 乘客不安全或不健康状况。</strong
              >如果乘客重病或者我们的医务人员或其他合格医务人员确定不宜出行，则承运人有权拒绝承运。
            </p>
            <p>
              <strong>12. 在先违规行为。</strong
              >如果基于我们的自由裁量，我们确定乘客之前在我们的任何航程中违反过我们的任何政策，包括但不限于我们的乘客健康、安全和行为政策，则承运人有权拒绝承运。
            </p>
            <p>
              <strong>13. 拒绝承运的一般理由：</strong
              >如果当我们自行决定认为拒绝承运是为了如下方面的最佳利益时，承运人有权拒绝承运：(a)
              任何游轮公司，(b)该乘客的舒适、愉悦、健康、福利或安全，（c）其他乘客的舒适、愉悦、健康、福利和安全，（d）我们任何员工的舒适、愉悦、健康、福利和安全，（e）我们的财产或者乘客或员工的财产免受损害。
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center"><strong>不与其他政策冲突</strong></p>
            <p>
              &nbsp;对本政策任何部分的解释，均不得以与我们其他政策相冲突的方式进行。除以上所述，我们的政策应互为解释说明，如果各政策任何部分之间存在歧义或冲突，对其的说明和解释（如若可能）应使得各部分继续有效且避免或尽可能减少相互之间的冲突。
            </p>
            <p></p>
            <p style="text-align: center">
              <strong>乘客健康、安全和行为政策</strong>
            </p>
            <p style="text-align: center"><strong>皇家加勒比集团</strong></p>
            <p style="text-align: center">
              <strong>（更新时间：2020 年 11 月 20 日）</strong>
            </p>
            <p>&nbsp;</p>
            <p>
              从公司成立至今，皇家加勒比国际游轮、名人游轮、银海游轮和精钻会游轮（在此统称为&ldquo;皇家加勒比集团&rdquo;、&ldquo;游轮公司&rdquo;、&ldquo;我们的&rdquo;或&ldquo;我们&rdquo;）一直致力于为乘客提供丰富多样的游轮体验，让乘客尽情享受非同寻常的假期之旅。无论是我们专业、友善的船员、无与伦比的船队、诸多丰富多彩的活动，还是不胜枚举充满异国风情的美丽目的地与岸上短途观光项目、精彩纷呈的娱乐表演或是丰盛可口的美味佳肴，都能让我们的乘客充分领略到为何皇家加勒比集团游轮假期能成为其难忘美好的度假体验之一。
            </p>
            <p>
              乘客们也会发现，游轮度假体验中最令人惊叹的部分之一，即游轮上的乘客来自世界各地，拥有不同的文化背景。这种多元性提供了了解世界不同地方及结交新朋友的契机。同时，虽然结交新朋友能提升度假体验，但某些乘客的行为举止可能会有些奇怪或令人不悦。为确保航程愉快，让各位熟悉了解皇家加勒比集团船舶上所适用的健康、安全和行为标准至关重要。
            </p>
            <p>
              本乘客健康、安全和行为政策（以下简称本&ldquo;政策&rdquo;）规定了在整个皇家加勒比集团游轮假期中乘客须遵循的行为标准，包括在上下船、港口码头内、登船后、沿途停靠港、岸上短途观光以及私属目的地等区域。制定和发布政策有助于确保所有乘客均能享受美好、安全和有保障的游轮度假体验。皇家加勒比集团感谢乘客们遵循本政策，并祝愿所有乘客能度过一个愉快、健康及难忘的航程。
            </p>
            <p>
              <strong
                >本政策适用于我们的船上、岸上码头、沿途停靠港及私属目的地。</strong
              >
            </p>
            <p>
              <strong
                >所有乘客都必须遵守本政策以及我们所有的健康和安全政策及程序，这是登船及在我们任何船舶或私属目的地逗留的条件。此外，乘客也必须遵守其前往旅游的各个国家所适用的法律。</strong
              >
            </p>
            <p>
              <strong
                >凡不遵守本政策、我们其他任何政策或我们（包括我们的船员）在任何时候以任何形式（书面或口头）传达的任何指示的乘客，将被视为违反本政策，并可能导致对其采取如下一项或多项强制措施，包括拒绝登船或在没有任何补偿或退款的情况下将其驱逐出游轮或私属目的地。在特定情况下，我们的强制措施可能不仅仅是将该乘客请下船，而且或将该乘客的旅行同伴或预订同行的其他乘客一并请下船。</strong
              >
            </p>
            <p>
              为本政策之目的，&ldquo;旅行同伴&rdquo;一词应给予尽可能广泛的解释，并且应包括但不限于：（1）在同一舱房或同一预订订单中的人，（2）在多个舱房或多个预订订单中的人，以及（3）我们判定其在旅程之前或期间的任何时期与该乘客拥有法定关系、社会关系或以任何方式有相近关系的人。
            </p>
            <p>
              <strong
                >本政策不影响船长根据国内法或国际法赋予的最高权力而做出和执行基于船长独立专业判断认为系保持船舶安全和保障所必要的决策。&nbsp;</strong
              >
            </p>
            <p>
              本政策的条款于前述日期生效，并将保持完全效力，除非我们自行决定更新或修改政策的全部或部分内容。本政策可能会进行更新或修改，该等更新或修改可不经公布而生效，但我们会尽力及时将政策的任何更新或修改发布至公开渠道，包括但不限于，皇家加勒比集团各网站或手机应用程序。
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center">
              <strong>我们对本政策的执行</strong>
            </p>
            <p>
              <strong
                >如果乘客实际违反或威胁违反本政策、我们的任何其他政策、我们（包括我们的船员）在任何时候以书面、口头或任何形式做出的指示，或按我们全权判断做出评估，认为乘客在船上或在我们的私属目的地，对我们的船舶、其他乘客或船员的健康、安全或保障造成威胁或风险，我们可能会采取以下一项或多项强制措施：</strong
              >
            </p>
            <ul class="leftPoint">
              <li>安保人员、其他管理人员或执法部门的干预;</li>
              <li>向主管政府当局和执法机关报告；</li>
              <li>
                取消某些船上特权，其中可能包括被拘留、隔离或限制在舱房内或隔离房间中；
              </li>
              <li>没收非法或违禁物品，基于我们的判断可将其移交至执法机关;</li>
              <li>拒绝登船或驱逐出游轮；</li>
              <li>拒绝其登上皇家加勒比集团未来任何游轮。&nbsp;</li>
            </ul>
            <p>
              <strong
                >我们根据本政策做出的任何决定、评估、判断、决策或强制措施，将由我们自行裁量并将是最终决定。乘客应自行承担强制措施相关费用。</strong
              >
            </p>
            <p>
              因不遵守本政策而被驱逐出皇家加勒比集团游轮或被拒绝承运的乘客应自行承担住宿和交通费用，回到乘客本国所需的任何文件也应由乘客自行负责。
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center"><strong>安全与保障</strong></p>
            <p><strong>始终遵循安保人员指示义务；安全检查</strong></p>
            <p>
              乘客无论是在码头、船上还是在目的地（包括我们的私属目的地），都必须遵守我们安保人员提供的全部指示。拒绝遵守安保人员指示将可能导致对您采取强制措施，包括拒绝您登船或被驱逐出游轮。
            </p>
            <p>
              登船之前（例如，在开始航行之前或在沿途停靠港），乘客应接受安全检查，并且在航行期间的任何时候，我们可以全权决定并要求乘客进行安全检查。我们也会要求为每位乘客拍摄安全照片。在拍摄安全照片或进行安全检验时，乘客会被要求暂时移去脸部遮盖物（例如，口罩）、帽子、装饰物或其他可能妨碍验证乘客身份的物品。拒绝进行安全检测或拒绝拍摄安全照片可能会导致其被拒绝登船或被驱逐出游轮。
            </p>
            <p>
              同样的，在启用面部识别功能登船或离船过程中，乘客可能会被要求暂时移去可能妨碍验证乘客身份的任何面部遮盖物（例如，口罩）、帽子、装饰物或其他物品。
            </p>
            <p>&nbsp;</p>
            <p><strong>强制安全演习</strong></p>
            <p>
              所有乘客都必须参加强制安全演习（也称为&ldquo;集合&rdquo;），并且作为强制安全演习的一部分，应遵守船长发出的所有健康及安全指示要求。登船后，乘客将有几个小时的空档期，在此期间，乘客必须（a）查看重要安全信息，并（b）至其指定集合点报到。在某些游轮上，我们鼓励乘客使用我们享有专利的eMusterTM系统，通过我们的手机应用程序或舱房电视观看安全演示录像、查看重要安全信息。无法通过eMusterTM观看安全演示录像或在登船后无法观看重要安全信息的乘客，则必须到指定集合点参加简短的安全演示介绍。
            </p>
            <p>&nbsp;</p>
            <p><strong>乘客通报义务</strong></p>
            <p>
              安全及保障是每个人的责任。在自己或他人受伤以及发现任何不安全或可能违法的行为时，乘客必须立刻向船上安保人员或其他船上管理人员进行通报。乘客可以通过拨打服务目录上列明的船上紧急电话、致电或到访乘客服务柜台或是联络船上安保人员或其他船上管理人员，来进行通报。
            </p>
            <p>
              未立即报告疾病、伤害、不安全或非法行为，可能会导致船员无法有效回应这种情况。任何拖延都可能导致船上无法准确保存信息或证据，并可能导致迟延通知相关执法人员或其他政府官员处理此事。
            </p>
            <p>
              您还可以在我们的网站或船上乘客服务柜台提供的&ldquo;健康、安全和保障指南&rdquo;中找到其他与通报有关的有用信息。
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center"><strong>健康</strong></p>
            <p>
              我们已采取诸多措施，以期在整个航行过程中为所有人提供一个健康的环境。为此，我们制定了与现行政府政策、法规和公共卫生指南相一致的政策和程序。
            </p>
            <p>
              <strong
                >乘客同意查阅和遵守所有健康或安全指南及其他张贴标识的指示。未如此行事的乘客将被采取强制措施，包括拒绝其登船或将其驱逐出游轮，同时，乘客的旅行同伴也可能被拒绝登船或驱逐出游轮。</strong
              >
            </p>
            <p>
              随着公共卫生指南的更新，我们也将相应更新我们的政策和程序。如有变化，我们将在开航前和航程中将与每次航程有关的政策和程序进行告知。
            </p>
            <p>
              此外，我们将告知如下信息：港口手续；上下船流程、社交距离及个人保护措施；船上设施使用；岸上观光活动（如有）；以及如发现可疑或确诊的传染病病例（例如，Covid-19）时采取的遏制和补救程序，包括接触者追踪程序和巡航结束后程序。
            </p>
            <p>
              <strong
                >我们保留拒绝任何出现传染病症状（包括Covid-19）或健康筛检结果表明他们可能患有此类疾病的乘客登船的权利。根据我们全权判断认为属于密切接触者或表现出传染病症状的任何乘客的旅行同伴（部分或全部旅行同伴），也可能被拒绝登船。</strong
              >
            </p>
            <p>
              请您参阅我们的隐私声明，以获取我们如何安全收集、保存、存储和共享（可能适用）乘客健康信息的相关信息。
            </p>
            <p>&nbsp;</p>
            <p><strong>强制登船前检测和筛检</strong></p>
            <p>
              登船之前将进行强制健康筛检，登船期间将实施特殊的健康和安全程序。这些程序很重要，所有乘客在登船之前必须遵从所提供的所有标识和指示。
            </p>
            <p>
              在整个健康筛检及登船的过程中，乘客必须向我们及我们的服务供应商提供清楚及准确的信息。在获取健康信息或执行与健康有关的任何职能的过程中，乘客也须配合我们、我们的代理商或服务提供商的工作。
            </p>
            <p>
              <strong
                >做为健康检查或健康评估的一部分，如若乘客拒绝提供健康信息或故意将不准确的健康信息提供给我们的医疗团队，则其可能会被拒绝登船、隔离或被采取其他强制措施。</strong
              >
            </p>
            <p>更多关于筛检和检测过程的详细信息，将在起航前提供给乘客。</p>
            <p>&nbsp;</p>
            <p><strong>船上健康监测</strong></p>
            <p>
              参加我们的健康监测和接触追踪程序是强制性的，但会基于实际情况进行合理安排。
            </p>
            <p>
              我们的疾病预防计划可能包括定期进行体温筛检，及/或传染病（例如，Covid-19）检测。我们可能也会要求乘客参加接触追踪程序，以帮助我们控制传染疾病（例如，Covid-19）的传播。这可能包括会要求乘客佩戴手环或其他可穿戴装置以进行技术接触追踪。
            </p>
            <p></p>
            <p><strong>传染病症状通报义务</strong></p>
            <p>
              <strong
                >出现任何传染性疾病症状的乘客，无论是否轻度，包括呈现新冠症状、腹泻或呕吐，都必须立即返回舱房并致电船上医疗机构，向船上医务人员报告。</strong
              >
            </p>
            <p>
              <strong
                >乘客还必须在旅行同伴出现症状时进行通报，或确保出现症状的人立即返回各自的舱房，并致电船上的医疗机构，向船上医务人员报告。</strong
              >
            </p>
            <p>
              <strong
                >无法立刻报告传染病情况或症状，或故意拒绝如实报告症状，构成对本政策的违反。</strong
              >
            </p>
            <p>
              新冠的症状包括但不限于高温或发烧、持续咳嗽、呼吸急促或呼吸困难，以及味觉丧失及改变、肌肉疼痛、头痛及疲劳等。
            </p>
            <p>
              <strong
                >在某些司法管辖区中，故意使他人暴露于传染病的行为可能构成犯罪。</strong
              >
            </p>
            <p>不遵守船员和/或医务人员发出的治疗指示，构成对本政策的违反。</p>
            <p>&nbsp;</p>
            <p><strong>隔离</strong></p>
            <p>
              基于我们的全权判断，我们可能会将乘客或乘客的旅行同伴，限制在他们的舱房内或进行隔离，以免将传染病或其他传染性疾病传播给其他船上或以外的人。乘客可能要移往专门为隔离/检疫而设的新客舱。
            </p>
            <p>
              所有乘客必须遵守隔离/检疫期间的所有指示，并在巡航结束后的下船过程中与船员充分合作。
            </p>
            <p>&nbsp;</p>
            <p><strong>洗手</strong></p>
            <p>
              乘客在如厕后或在进食或接触食物前，必须用肥皂和热水将双手洗净。医生认为，洗手是防止感染肠道病毒、感冒、流感等传染性疾病的最佳方法之一，在如厕后或在进食或接触食物前，要用肥皂和热水洗手至少二十秒以上。
            </p>
            <p>&nbsp;</p>
            <p><strong>参观港口和岸上观光</strong></p>
            <p>
              在某些停靠港，我们可能会基于我们的全权判断，仅允许某些参加我们指定岸上短途观光项目的乘客离船上岸。在此情况下，乘客将必须在离船后与该指定岸上短途观光团体一起游览和行动，并遵循我们、短途观光运营方和适用的司法辖区内关于健康和安全的所有指示。
            </p>
            <p>
              在停靠港下船或上船的乘客，可能需要接受其他强制性的健康筛检和检查。在停靠港上岸前，我们会将其他健康筛检和检查的详情提供给乘客。请注意，停靠港的当地主管机关，在下船和/或登船时还可能要求对乘客进行额外的筛检和检测，乘客必须遵守这些要求。
            </p>
            <p>&nbsp;</p>
            <p><strong>旅行健康条件 - 残障旅客</strong></p>
            <p>
              我们并不将残障旅客一定要有他人陪同做为进行我们的游轮旅行的条件之一。然而，所有乘客必须考虑到，船员并没有义务必须去协助乘客完成私人任务或解决个人卫生需求（例如，协助进食、着装及如厕）。因此，需要协助才能进行这些行为的乘客在计划游轮假期时，应考虑到这些需求。在预订游轮假期之前，如果乘客不能确定是否有能力独立照顾自己的个人需求或个人卫生且不会对自己或他人构成危险，但仍计划独自旅行的，那么其须与游轮公司的运营部门讨论这个情况，以使我们能够对乘客的身体状况在没有协助情况是否适合政策游轮行程进行单独评估。无法独立照顾自己个人需求的乘客试图登船或登船后被发现的，我们将对其进行评估以确定其是否适合在没有协助的情况下安全旅行。被发现不适合旅行的乘客可能会被拒绝登船或在下一个停靠港口被请下船，并无权获得赔偿或退款。
            </p>
            <p>&nbsp;</p>
            <p><strong>药物治疗</strong></p>
            <p>
              乘客在整个航行过程中须充分携带其所需药物。我们建议乘客备有充足且在航行结束后还能持续几天药量的药物，以备由于遇恶劣天气或其他不可预见情况而可能造成延误之时的需要。船上的医疗机构可能没有某些所需药物，并且并非所有的药物都可以在停靠港获得。
            </p>
            <p>
              为了确保可以随时取用药品，乘客不应将药品放在托运行李中。反之，乘客应将药物放在手提行李中随身携带上船。
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center"><strong>乘客的行为</strong></p>
            <p><strong>禁止乘客和船员之互动</strong></p>
            <p>
              游轮工作人员都是非常友好、随和且乐于助人的，他们将竭尽所能让乘客宾至如归。但请不要误解他们的善意。船员禁止与乘客进行身体接触。游轮工作人员不得与乘客进行超出专业职责范围的社交活动，也不得进入舱房（除非是为了履行其船上工作）。我们期望乘客尊重这些政策，并避免与船上工作人员发生身体接触。乘客不得擅自进入非开放区域或员工区域（包括船员的舱房和走廊）。
            </p>
            <p>&nbsp;</p>
            <p><strong>禁止粗言秽语或威胁</strong></p>
            <p>
              禁止向任何人（包括乘客、船员、政府官员或其他人）使用粗言秽语。禁止威胁的说辞和行为，禁止违法行为。
            </p>
            <p>
              企图自残或以口头或书面的方式陈述或以行为表明其意图自残的，我们的船员或安保人员将对其采取强制措施，以保护游轮以及乘客、船员的生命健康和安全。
            </p>
            <p>&nbsp;</p>
            <p><strong>禁止不得体行为或粗暴行为</strong></p>
            <p>
              禁止不得体或粗暴的行为，包括：令人不悦的肢体接触、引诱、骚扰、蓄意破坏、窃盗、暴力、使用虚假身份证明、未成年人饮酒（参见以下酒精饮料部分）、向未满饮酒年龄规定的乘客提供酒精饮品（参见以下酒精饮料部分）、拥有非法物质/物品、在船体表面任何地方放置物料（包括标志、标语、装饰品等）、未经船舶管理部门的明确许可将物料放置在船舶内部的任何地方（包括舱室门、走廊等）或其他任何被船舶管理人员视为不当、非法或冒犯行为。
            </p>
            <p>&nbsp;</p>
            <p><strong>禁止危险行为</strong></p>
            <p>严格禁止不遵守健康、安全或保障指示或政策的行为。</p>
            <p>
              禁止扶坐、站立、跳跃、躺卧或攀爬于任何船只内外部栏杆或其他防护栏。
            </p>
            <p>此外，禁止改动或损毁船舶的任何设备、设施或系统。</p>
            <p>其他根据我们全权决定认为属于危险行为的，同样受到禁止。</p>
            <p>&nbsp;</p>
            <p><strong>禁止无礼或破坏行为</strong></p>
            <p>
              游泳池、甲板或剧院座位可能不接受提前预定，为残障人士预留座位除外。禁止公开裸露。乘客必须穿着得体，包括在其客舱阳台上（如果该阳台是本船、他船或陆地上的人可见）。禁止裸露上身享受日光浴，但特定行程除外（即便如此也只能在特定区域进行）。有关着装要求的更多信息，请联系乘客服务柜台。
            </p>
            <p>
              禁止使用扬声器、音量大的收音机或制造其他有害噪音。不得在船上使用直排轮滑鞋、溜冰轮鞋、滑板、冲浪板、自行车和类似物品。禁止使用踏板车，但作为行动辅助则除外。
            </p>
            <p>&nbsp;</p>
            <p><strong>在船上吸烟及购买烟草产品的限制</strong></p>
            <p>
              为了乘客之舒适和愉悦，游轮上禁止吸烟。这包括禁止使用水烟壶和其他类型设水烟装置。
            </p>
            <p>
              任何舱房内或舱房阳台上都禁止吸烟。这项禁令适用于船上所有类型的舱房。乘客违反禁烟政策，其帐上将被计入一笔清洁费。在所有的餐饮地点、剧场、酒吧、酒廊、走道、电梯、慢跑步道或是大多数的室内区域，都禁止吸烟。此外，在特定的室外区域，包括限制区、餐饮区及儿童游乐场与泳池，也禁止吸烟。
            </p>
            <p>
              然而，我们了解有些乘客有吸烟的需要。因此，为了提供让吸烟者也能感到满意的环境，我们将船上某些区域指定为吸烟区。为便于吸烟乘客找到吸烟区，我们在船上吸烟区都张贴了吸烟标记并提供吸烟使用的烟灰缸。乘客也可以向乘客服务柜台问询船上吸烟区地点。
            </p>
            <p>
              在行程中准许吸烟的娱乐场内，我们张贴明显标志以区分吸烟区及无烟区。
            </p>
            <p>
              雪茄及烟斗仅限特定的户外区域及雪茄吧（如该游轮内设有）享用。电子烟仅能在指定的吸烟区内使用。
            </p>
            <p>香烟、雪茄及烟斗烟草必须在用后妥善丢弃且不得丢出船外。</p>
            <p>乘客必须要至少年满18岁才能在船上购买、拥有或吸食烟草产品。</p>
            <p>&nbsp;</p>
            <p><strong>宵禁</strong></p>
            <p>
              船上管理人员保留对特定个人、团体或全船人员实施宵禁的权利，如若根据船长的独立判断，采取宵禁是保护乘客或船员健康及安全所必要的。
            </p>
            <p>&nbsp;</p>
            <p><strong>父母及监护人责任</strong></p>
            <p>
              为本政策之目的，未成年人是指18周岁以下的自然人。年轻成人是指18、19或20岁的自然人。在整个假期期间，父母及监护人须对同行的未成年人和年轻成人的行为负责，并实施适当监督，包括在上下船时、码头内、登船后、沿途停靠港、岸上短途观光期间以及我们的私属目的地。上述责任在任何情况下均适用，无论该未成年人或年轻成人的父母或监护人是否在场。
            </p>
            <p>
              在任何情况下，未成年人的父母或监护人均不得在没有陪伴同行未成年人的情况下下船，除非其已安排成年责任人在其离船时在船上陪伴并监督该未成年人。在港口停留时，在没有成年责任人监督陪伴的情况下，父母或监护人不得允许他们所照管的未成年人离开船只。
            </p>
            <p>&nbsp;</p>
            <p><strong>酒精饮料</strong></p>
            <p>
              过量饮酒将影响个人的判断能力，致使其辨别和避免潜在危险情况的能力被降低。因此，乘客饮酒应适可而止。船上工作人员可自行决定拒绝向任何过量饮酒的乘客提供酒精饮品，也可根据本政策要求乘客出示跟人身份证件，以确认其是否已达到本政策规定的饮酒年龄。成年乘客禁止向未成年人及年轻成人提供酒精饮品。严禁所有斗酒游戏。
            </p>
            <p>
              从北美、阿拉伯联合酋长国启程的游轮，或在我们的任何私属目的地，乘客饮酒或拥有酒精饮料的最低年龄为21周岁。在从南美洲、欧洲、亚洲、澳大利亚和新西兰启程的船上，乘客饮酒或拥有酒精饮料的最低年龄为18周岁。在所有其他情况下，游轮行程始发地的法定饮酒年龄将决定我们如何判断法定饮酒年龄。
            </p>
            <p>
              在某些当地法律允许或要求的情况下，皇家加勒比集团可以修改此政策，这也可能需要父母或监护人提出要求或授权。乘客可联络乘客服务柜台或在其舱房中查询游轮信息，以了解其游轮假期的最低饮酒年龄限制。为了遵守最小饮酒年龄的规定，游轮假期开始时就会先了解乘客年龄。如果乘客在游轮假期中度过生日并达到法定饮酒年龄，那么此后，乘客可以要求乘客服务经理修改资料，以允许他们在剩余航程中饮酒。该乘客必须前往乘客服务柜台，出示政府签发的有效身份证件，以验证其年龄。
            </p>
            <p>
              除非我们的安保人员或船员另有许可，否则乘客禁止携带酒精饮料;登船日允许每客舱携带最多两（2）个密封的750毫升瓶装葡萄酒或香槟上船，前提是该客舱中至少有一位乘客已达到饮酒年龄。盒装葡萄酒和其他容器不可携带上船。安保人员可以随时检查容器（包括水瓶、汽水瓶、漱口水、水壶等），并可处置隐藏在这些容器中的酒精。从船上商店或停靠港购买的酒精饮料必须在重新上船时呈交给安保人员，并由保管。由船上工作人员保管的酒精饮料将在游轮假期结束之前返还给乘客。酒精饮料将不会退还给尚未达到法定饮酒年龄的乘客。
            </p>
            <p>
              任何上岸喝酒的乘客（无论是否在父母/监护人的监督下）均应确保理性消费，并能保持清醒意识上船且保有避免潜在危险的能力。特此提醒父母/监护人，在皇家加勒比集团乘船度假期间，必须始终对未成年人和年轻成人的行为负责。
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center"><strong>违禁品</strong></p>
            <p>
              <strong
                >在进行安全检查期间，我们可能会检查乘客的随身物品，并且可能会在乘客不在场的情况下取走相关违禁品。若乘客未在物品被没收后的15日内领取，则该物品将被视为丢弃，可由皇家加勒比集团任意处置。</strong
              >
            </p>
            <p>&nbsp;</p>
            <p><strong>发热或产生明火的物品</strong></p>
            <p>
              禁止携带可释放热量或产生明火的物品登船，包括熨斗、电热盘、蜡烛、香薰或任何其他可能引起火灾的物品。电卷棒及吹风机允许带上船。
            </p>
            <p>&nbsp;</p>
            <p><strong>禁止大麻</strong></p>
            <p>即便是药用或作为医疗用途，大麻都是被禁止的。</p>
            <p>&nbsp;</p>
            <p><strong>禁止毒品或其他非法物品 </strong></p>
            <p>
              禁止携带违禁毒品或其他非法物品上船，也不得在皇家加勒比集团游轮假期期间，包括在上下船、码头内、登船后、停靠港、岸上短途观光或在我们的私属目的地期间吸食毒品或使用其他非法物品。对于非法毒品或物品，游轮工作人员将予以没收，同时皇家加勒比保留自行决定向有关当局通报违反该禁令的权利。整个航程中的司法管辖区可能都有关于持有毒品的严格法律规定。若发现乘客触犯相关法律，则该有管辖权的国家（美国或其他国家）有权将其逮捕并对该乘客提起诉讼，并游轮有权拒绝该乘客登船或重新登船。
            </p>
            <p>&nbsp;</p>
            <p><strong>禁止武器、爆裂物和其他危险物品</strong></p>
            <p>
              禁止物品的详细列表可在我们的网站上找到，并在此以引用方式并入本政策。
            </p>
            <p>
              禁止携带武器、弹药、爆裂物、烟火或其他可能对人身或财产造成伤害的物品上船。皇家加勒比集团将自行决定确定哪种物品可能会对人身或财产造成伤害。一经发现，船上安保人员将立即予以没收。
            </p>
            <p>
              禁止携带枪支和其他武器上船。向船员表明携带枪支或其他武器（随身携带或在其行李中）的乘客可在登船前将该物品处理掉。未声明携带枪支或其他武器的乘客，可能会被拒绝登船或被驱逐出游轮。潜水刀等物品必须在登船时向船上工作人员汇报，此类物品可能会被允许带上船，但是在上岸使用前后应交由船上安保人员进行保管。
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center"><strong>环境保护</strong></p>
            <p>
              <strong>Save the Waves&reg;拯救海洋项目与垃圾/废物处理</strong>
            </p>
            <p>
              皇家加勒比集团实施SaveWaves&reg;拯救海洋项目，聚焦三项基本原则：减少废弃物产生数量;尽可能回收利用;合理处置剩余垃圾。垃圾应妥善处理，乘客应将垃圾丢弃于指定的垃圾箱或舱房的废弃楼中。切勿将垃圾或其他异物冲进马桶内，也得将任何物品丢至船外。乘客不得将物品放在阳台上无人看管，因为海风可能会将物品吹落至船外。
            </p>
            <p>&nbsp;</p>
            <p style="text-align: center">
              <strong>其他适用的年龄政策</strong>
            </p>
            <p>
              乘客必须年满18周岁才能进入我们船上的娱乐场，但阿拉斯加航线乘客须年满21周岁。船上的各种场所和活动都有最低年龄限制。乘客可以在我们的网站或询问乘客服务柜台获取相关信息。
            </p>
            <p>&nbsp;</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookingLegalPopup",
  props: {
    isShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      isShowModal: false,
    };
  },
  methods: {
    onModalClose() {
      this.isShowModal = false;
      setTimeout(() => {
        this.$emit("onModalClose");
      }, 100);
    },
  },
  watch: {
    isShow(newValue) {
      setTimeout(() => {
        this.isShowModal = newValue;
      }, 100);
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  padding: 20px;
}
.modal-dialog {
  top: 15%;
}
.booking_rule_hd {
  font-size: 14px;
  color: #282b2c;
  margin-bottom: 20px;
  font-weight: bold;
  text-align: center;
}

.booking_rule_bd {
  max-height: 500px;
  overflow: scroll;
  > p {
    margin-bottom: 6px;
  }
  ol {
    padding-left: 20px;
  }
  ul,
  li {
    list-style: initial;
  }
  ol {
    li {
      list-style-type: decimal;
    }
  }

  ul {
    li {
      list-style-type: circle;
    }
  }

  li {
    margin-bottom: 10px;
  }
}

.modal {
  .common-modal-close {
    position: absolute;
    width: 28px;
    top: 3px;
    right: 5px;
    z-index: 2;
    cursor: pointer;
  }
}

.modal.active {
  display: block;
  overflow-x: hidden;
  overflow-y: scroll;
}

.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.leftPoint{
  padding-left: 30px;
}
</style>
